import React, { useCallback } from 'react';
import { navigateToSalesPortalRoute } from '@/experiences/sales-portal/sales-portal-route-config';
import {
  NavigationProp,
  useIsFocused,
  useNavigation,
} from '@react-navigation/native';
import { SALES_PORTAL_ROUTES } from '@/navigators/routes';
import { SalesHubShellTemplate } from '@/experiences/sales-portal/templates/sales-hub-shell-template';
import {
  SalesHubSidebarNavItem,
  useSalesHubSidebarNavItemsLoader,
} from '@/experiences/sales-portal/containers/sidebar/blocs/loaders/use-sales-hub-sidebar-nav-items-loader';
import { SalesPortalNotFoundScreen } from '@/experiences/sales-portal/screens/sales-portal-not-found-screen';
import { SalesPortalTabParams } from '@/navigators/types';
import { Spinner } from '@usepepper/sprout-kit-ui';
import { StyleSheet, View } from 'react-native';

export const SalesPortalHomeScreen: React.FC = () => {
  const navigation = useNavigation<NavigationProp<SalesPortalTabParams>>();
  const isFocused = useIsFocused();

  const redirectToFirstProduct = useCallback(
    (navItems: SalesHubSidebarNavItem[]) => {
      if (!isFocused) {
        return;
      }

      const first = navItems[0];
      if (!first) {
        return;
      }

      if (first.route) {
        navigateToSalesPortalRoute(navigation, first.route, first.params);
      } else {
        navigation.navigate(SALES_PORTAL_ROUTES.Base, { productId: first.id });
      }
    },
    [isFocused, navigation],
  );

  const { loading } = useSalesHubSidebarNavItemsLoader({
    onComplete: redirectToFirstProduct,
  });

  return (
    <SalesHubShellTemplate>
      {loading ? (
        <View style={styles.loadingContainer}>
          <Spinner size="large" />
        </View>
      ) : (
        <SalesPortalNotFoundScreen />
      )}
    </SalesHubShellTemplate>
  );
};

const styles = StyleSheet.create({
  loadingContainer: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
});
